import React from 'react';
import PropTypes from 'prop-types';
import Chip from '@mui/material/Chip';

export const TRAILER_STATUS_LABEL = {
  ACTIVE: 'Active',
  DEACTIVATED: 'Deactivated',
  GRACE: 'Grace Period',
  INACTIVE: 'Inactive',
  PENDING: 'Pending',
  WARNING: 'Warning',
};

export const TRAILER_STATUS_COLOR = {
  ACTIVE: 'blue.light',
  DEACTIVATED: 'error.main',
  GRACE: 'blue.light',
  INACTIVE: 'default',
  PENDING: 'warning.main',
  WARNING: 'error.dark',
};

export const TRAILER_STATUS_TIP = {
  ACTIVE: '',
  DEACTIVATED:
    'Magellan has activated this trailer with a 7-day grace period. However, the required documentation has not been submitted and the trailer is not able to load at a Magellan Terminal until the required documentation is submitted.',
  GRACE:
    'Magellan has activated this trailer with a 7-day grace period. Please ensure that all required documentation and trailer capacity are submitted within this time frame. Failure to do so will result in the trailer being deactivated and unable to load.',
  INACTIVE: '',
  PENDING: 'Click on view trailer for pending updates.',
  WARNING: 'Click on view trailer for error updates.',
};

const TrailerStatusChip = ({ status }) => {
  return (
    <Chip
      label={TRAILER_STATUS_LABEL[status]}
      size="small"
      sx={{
        bgcolor: TRAILER_STATUS_COLOR[status],
        color: ['DEACTIVATED', 'WARNING'].includes(status) ? 'surface.white' : 'text.primary',
      }}
    />
  );
};

TrailerStatusChip.propTypes = {
  status: PropTypes.oneOf(['PENDING', 'ACTIVE', 'INACTIVE', 'WARNING', 'GRACE', 'DEACTIVATED'])
    .isRequired,
};

export default TrailerStatusChip;
